import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const ErrorMessage = ({ children }) => {
    const StyledErrorMessage = styled.div`
        color: white;
        padding: 3em;
        background-color: #BA335C;
    `;

    const StyledLink = styled.a`
        color: white;
        text-decoration: underline;
    `;

    return (
        <StyledErrorMessage>
            <FormattedMessage
                id='DEFAULT_ERROR_MESSAGE'
                defaultMessage="Ooops, wir haben ein ernstes Problem. Du kannst versuchen die Seite neu zu laden. Wenn das nicht hilft, wäre es zu nett, wenn Du uns einen Screenshot mailst."
            />
            <br />
            <StyledLink href='mailto:admin@schnoffle.de'>admin at schnoffle.de</StyledLink>
            {children || null}
        </StyledErrorMessage>
    );
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/common/ErrorMessage.js